// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__w88C6","item":"Tabs_item__XRP9H","select":"Tabs_select__Ag4Ax","canHover":"Tabs_canHover__pA82s"};